var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.162 5.656C21.3986 5.99369 20.589 6.21547 19.76 6.314C20.6338 5.79143 21.2877 4.96901 21.6 4C20.78 4.488 19.881 4.83 18.944 5.015C18.3146 4.34158 17.4804 3.89496 16.571 3.74458C15.6616 3.59421 14.7279 3.74849 13.9153 4.18345C13.1026 4.61841 12.4564 5.30968 12.0771 6.14979C11.6978 6.9899 11.6068 7.93178 11.818 8.829C10.1551 8.74565 8.52833 8.31352 7.04329 7.56066C5.55824 6.8078 4.24813 5.75105 3.198 4.459C2.82629 5.09745 2.63096 5.82323 2.632 6.562C2.632 8.012 3.37 9.293 4.492 10.043C3.82801 10.0221 3.17863 9.84278 2.598 9.52V9.572C2.5982 10.5377 2.93237 11.4736 3.54385 12.2211C4.15533 12.9685 5.00648 13.4815 5.953 13.673C5.33662 13.84 4.69031 13.8647 4.063 13.745C4.32987 14.5762 4.85001 15.3032 5.55059 15.8241C6.25118 16.345 7.09713 16.6338 7.97 16.65C7.10248 17.3313 6.10918 17.835 5.04688 18.1322C3.98458 18.4294 2.87413 18.5143 1.779 18.382C3.6907 19.6114 5.9161 20.2641 8.189 20.262C15.882 20.262 20.089 13.889 20.089 8.362C20.089 8.182 20.084 8 20.076 7.822C20.8949 7.23017 21.6016 6.49702 22.163 5.657L22.162 5.656Z",
    fill: "#232233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialicon3);
export default __webpack_public_path__ + "static/media/socialicon3.7fb8582abfa724dcac42e33554c4aafd.svg";
export { ForwardRef as ReactComponent };